import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import useGetVsic from '../../../../../../common/category/useGetVsic'
import { Table } from '../../../../../../common/table'
import {
  selectCompareIndustry,
  selectDefaultIndustry,
} from '../../../store/slice'
import { TBodyCustom } from './TBodyCustom'

export const TableGeneralAnalysis = ({
  dataTable,
  isDynamicReport,
  settingDynamic = {},
}) => {
  const vsicDefaultStore = useSelector(selectDefaultIndustry)
  const vsicCompareStore = useSelector(selectCompareIndustry)
  const { vsics } = useGetVsic()
  const { ids, selectData, selectRowGroup, selectCellData, loading } = dataTable

  const { DEFAULT_INDUSTRY: vsicDefaultDyn, COMPARE_INDUSTRY: vsicCompareDyn } =
    settingDynamic
  const vsicDefault = isDynamicReport ? vsicDefaultDyn : vsicDefaultStore
  const vsicCompare = isDynamicReport ? vsicCompareDyn : vsicCompareStore

  const titleDefaultIndustry = vsics.find(
    (item) => item.id === vsicDefault,
  )?.name
  const titleComparingIndustry = vsics.find(
    (item) => item.id === vsicCompare,
  )?.name

  const schema = useMemo(() => {
    const baseHeaders = [
      {
        title: 'companyAnalysis.industryAnalysis.GROUP',
        colId: 'group',
        isI18n: true,
      },
      {
        title: 'companyAnalysis.industryAnalysis.RATIO_1',
        colId: 'ratioName',
        isI18n: true,
        thStyle: {
          justifyContent: 'flex-start',
        },
      },
      {
        title: titleDefaultIndustry,
        colId: 'defaultIndustry',
        colCustomId: 'defaultIndustryChange',
        thStyle: {
          justifyContent: 'flex-end',
        },
        renderTh: (val) => (
          <div
            style={{
              maxWidth: 200,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'left',
            }}
          >
            {val}
          </div>
        ),
      },
    ]
    if (vsicCompare) {
      baseHeaders.push({
        title: titleComparingIndustry,
        colId: 'compareIndustry',
        colCustomId: 'comparingIndustryChange',
        thStyle: {
          justifyContent: 'flex-end',
        },
        renderTh: (val) => (
          <div
            style={{
              maxWidth: 200,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'left',
            }}
          >
            {val}
          </div>
        ),
      })
    }
    return baseHeaders
  }, [vsicDefault, vsicCompare, titleDefaultIndustry, titleComparingIndustry])

  return (
    <Table
      ids={ids}
      isLoading={loading}
      isNoDataWithHead={false}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isDynamicReport={isDynamicReport}
      getDataFromRedux={selectData}
      schema={schema}
      renderTBody={() => {
        return (
          <TBodyCustom
            ids={ids}
            selectCellData={selectCellData}
            selectRowGroup={selectRowGroup}
            schema={schema}
            isDynamicReport={isDynamicReport}
          />
        )
      }}
    />
  )
}
